import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 16h10","key":"svg-0"}],["path",{"d":"M11 16l4 4","key":"svg-1"}],["path",{"d":"M11 16l4 -4","key":"svg-2"}],["path",{"d":"M13 8h-10","key":"svg-3"}],["path",{"d":"M13 8l-4 4","key":"svg-4"}],["path",{"d":"M13 8l-4 -4","key":"svg-5"}]]

const IconArrowsDiff = createReactComponent('outline', 'arrows-diff', 'ArrowsDiff', __iconNode);

export default IconArrowsDiff;